import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { interval } from 'rxjs';
import { BaseClass, ResFormat } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
// import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseClass<any> implements OnInit {

  @ViewChild('staticTabs', { static: false }) staticTabs?: TabsetComponent;

  public data: any;
  public exchangeData: any;
  public casinoData: any;
  public inPlayData: any;
  public listRes: any;
  public marketsReq: any[] = [];
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public oddsLisDisNew: any = {};
  public exposLisDis: any = {};
  public newOddsEnable: boolean = false;
  public marketData: any;
  public tabId: any = 'in_play';
  public tabSet: any;

  public menuItems: any[] = [];
  public id: any;
  public compName: any;
  public hRaceList: any[] = [];
  public gRaceList: any[] = [];
  public queryPrm: any = {
    sId: 0
  }
  public checkKey: boolean = true;

  // public _pusher!: PusherService;

  constructor(
    public service: WebserviceService,
    public _shared: SharedService,
    public _common: CommonService,
    public actRoute: ActivatedRoute,
    private injector: Injector,
    public router: Router,
  ) {
    super(document);
    this.constructorCallData();
  }

  constructorCallData() {
    // if (this.isLogin()) {
    //   this._pusher = this.injector.get<PusherService>(PusherService);
    //   const sub1 = this._pusher.eventListUpdate().subscribe(res => {
    //     if (res?.op == 'UPDATE') {
    //       this.getData();
    //     }
    //   });
    //   this.subs.push(sub1);
    // }

    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.webSocketUrl != '') {
        if (this.newOddsEnable == true) {
          this.getOddsNew(this.marketsReq, this.marketData);
        } else {
          this.getOdds(this.marketsReq);
        }
      }
    });
    this.subs.push(sub2);

    const sub3 = this._shared.sharedTabSet.subscribe((rp: any) => {
      if (rp) {
        this.tabSet = rp;
      }
    });
    this.subs.push(sub3);

    this.actRoute.queryParams.subscribe(params => {
      this.queryPrm.sId = params['sId'] ? params['sId'] : '';
    });
  }

  ngOnInit(): void {
    this.id = this.actRoute.snapshot.paramMap.get('id');
    this.compName = this.actRoute.snapshot.paramMap.get('compName');
    //this.getCasinoData();
    this.setMenu();
  }


  getServices(): IbaseService<any> {
    return this.service;
  }

  otherMenu: any[] = [];
  casinoMenu: any[] = [];
  setMenu() {
    if (this.actRoute.snapshot.paramMap.get('id')) {
      this.id = this.actRoute.snapshot.paramMap.get('id');
      if (this.id == 'inplay') {
        this.menuItems = [{ id: 'in_play', name: 'in-play' }];
        this.tabId = 'in_play';
      } else {
        this.menu.forEach((element: any, i: number) => {
          if (element.id == this.actRoute.snapshot.paramMap.get('id')) {
            this.menuItems = [element];
            this.tabId = element.id;
          }
        });
      }

      // if (this.events.races.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
      //   this.getRaceListData(this.actRoute.snapshot.paramMap.get('id'));
      // } else
      if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id')))) {
        if (this.data) { } else {
          this.getData();
        }
      }

    }
    else {
      this.menuItems = [];
      this.otherMenu = [];
      this.casinoMenu = [];
      this.menu.forEach((element: any, i: number) => {
        if (this.events.sports.includes(element.id)) {
          if (element.id != 4) {
            this.menuItems.push(element);
          } else {
            this.menuItems.unshift(element);
          }
        } else if (this.events.casino.includes(element.id)) {
          this.casinoMenu.push(element);
        } else {
          this.otherMenu.push(element);
        }
      });
      //console.log(this.otherMenu);

      // this.menuItems = this.menu;
      if (this.menuItems) {
        this.menuItems.unshift({ id: 'in_play', name: 'Inplay' })
        this.menuItems.push({ id: 'casino', name: 'Casino' })
        this.menuItems.push({ id: 'others', name: 'Others' })
      }
      if (!this.events.casino.includes(Number(this.actRoute.snapshot.paramMap.get('id'))))
        this.getData();
    }


  }

  getUserData() {
    if (this.isLogin()) {
      this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
        (res) => {
          if (res) {
            this.setUserData(res);
            this.userData = this.getLocalItem('user');
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  getData() {
    this.isLoad = true;
    this.data = undefined;
    this.inPlayData = undefined;
    let api = this.isLogin() ? this.api.eventListNew : this.api.eventListNewG;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res: ResFormat) => {
        if (res.status == true) {
          // res.data.events = this.UTC_to_Local_timeZone(res.data.events);
          this.listRes = res.data;
          this.setLocalItem('sideMenu', res.data.events);
          this._shared.emitSideMenu(res.data.events);
          this.setRaceSideMenu(7, res.data.races);
          this.setRaceSideMenu(4339, res.data.races);
          res.data.events.forEach((element: any) => {
            element['runner'] = element.name.split(' v ');
            if (element['runner'].length == 1) {
              element['runner'] = element.name.split(' VS ');
            }
          });
          // res.data.events.forEach((element: any) => {
          //   element['runner'] = element.name.split(' Vs ');
          // });
          res.data.races.forEach((element: any) => {
            element['in_play'] = 1;
          });
          let events = [...res.data.events, ...res.data.races];

          this.hRaceList = this.findUpComingRace(res.data.races, 7);
          this.gRaceList = this.findUpComingRace(res.data.races, 4339);

          this.exchangeData = events;
          this.commonLogics(res, events);
          // if(this.isLogin()){
          //   this.getUserData();
          // }

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  setRaceSideMenu(id: any, items: any) {
    let dt = items.filter((s: any) => { return Number(s.event_type_id) == Number(id) });
    this.setLocalItem(`sideRaceMenu${id}`, dt);
    this._shared.emitSideMenu(dt);
  }

  findUpComingRace(list: any, id: any) {
    var lt = list.filter((event: any) => event.event_type_id == id);

    const now = new Date();
    const nextHour = new Date(now.getTime() + 60 * 60 * 1000);

    lt = lt.filter((race: any) => {
      const raceStartTime = new Date(race.market_start_time_format);
      return raceStartTime >= now && raceStartTime <= nextHour;
    });

    return lt;
  }

  getCasinoData() {
    let api = this.isLogin() ? this.api.casino1 : this.api.casino1G;
    this.getServices().Get(`${this.env.baseUrl + api}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.casinoData = res.data;
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getRaceListData(id: any) {
    this.isLoad = true;
    this.data = undefined;
    this.inPlayData = undefined;
    let api = this.isLogin() ? this.api.raceList : this.api.raceListG;
    this.getServices().Get(`${this.env.baseUrl + api}/${id}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.setLocalItem(`sideRaceMenu${id}`, res?.data?.race);
          this._shared.emitSideMenu(res?.data?.race);
          res.data.race.forEach((element: any) => {
            element['in_play'] = 1;
            element['event_type_id'] = Number(id);
          });
          this.commonLogics(res, res?.data?.race);

        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  commonLogics(res: any, events: any) {
    this.webSocketUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
    this.setLocalItem('ws', this.webSocketUrl, false);
    events = this.UTC_to_Local_timeZone(events);
    this.marketsReq = this.genMarketReq(events);

    this.marketData = res?.data;
    this.data = events;
    this.inPlayData = this.getInplayData(events);
    this.isLoad = false;

    if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
      this.newOddsEnable = true;
      this.getOddsNew(this.marketsReq, res?.data);
    } else {
      this.newOddsEnable = false;
      this.getOdds(this.marketsReq);
    }
    if (this.isLogin())
      this.getExposure(this.marketsReq);

  }

  getOdds(req: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.odds}`, req).subscribe(
      (res) => {
        res = this.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId ? elt.marketId : elt.market_id]: elt })));

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getOddsNew(req: any, resData: any) {
    this.getServices().Post(`${this.webSocketUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        res = this.pipe_string_to_JSON(res);
        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);

        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;

        this.isLoad = false;
      },
      (err) => {
        console.log(err);
      });
  }

  getExposure(req: any) {
    this.getServices().Post(`${this.env.baseUrl + this.api.exposure}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          res = res.data.exposes;
          // res = this.string_to_JSON(res);
          res.forEach((element: any) => {
            if (typeof element?.expo !== 'undefined') {
              element["expo"] = element.reduce((a: any, b: any) => { return (b.expose < a.expose) ? b : a; });
              // let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
              this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = element;
            }
          });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  genMarketReq(res: any) {
    let market: any[] = [];
    res.forEach((element: any) => {
      market.push('market_ids[]=' + encodeURIComponent(element.market_id));
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];

    return market.join('&') as any;
  }

  onSelect(data: any): void {
    // this.data = undefined;
    this.tabId = data.id;
    if (this.events.races.includes(data.id)) {
      // this.isLoad = true;
      // this.getRaceListData(data.id);
    } else if (!this.events.casino.includes(data.id)) {
      // this.getData();
    }
  }

  getInplayData(data: any) {
    const groupedInPlay = this.groupBy(data, (dat: any) => dat.in_play);
    const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);

    // let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]
    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : []]

    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
    const groupedCat = this.groupBy(uniqueArray, (dat: any) => dat.event_type_id);
    var cricketEvents = groupedCat.get(4) ? groupedCat.get(4) : [];
    var otherEvents = uniqueArray.filter((e: any) => { return (e.event_type_id != 4) })
    const inplay = [...cricketEvents, ...otherEvents];

    return inplay;
  }

  onSelectStatic(tabId: any): void {
    this.router.navigate(['/dashboard'], { queryParams: { sId: tabId } });
  }

  onLoadSelectStatic(tabId: any): void {
    if (this.staticTabs?.tabs[tabId]) {
      this.staticTabs.tabs[tabId].active = true;
    }
  }

  ngAfterContentChecked() {
    if (this.checkKey == true && this.staticTabs) {     
      this.onLoadSelectStatic(this.queryPrm.sId);
      this.checkKey = false;
    }
  }

  ngDoCheck() {
    if (this.id && this.id != this.actRoute.snapshot.paramMap.get('id')) {
      this.id = this.actRoute.snapshot.paramMap.get('id');
      this.setMenu();
    }
    if (this.compName && this.compName != this.actRoute.snapshot.paramMap.get('id')) {
      this.compName = this.actRoute.snapshot.paramMap.get('compName');
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
    // if (this.isLogin() && this._pusher) {
    //   this._pusher.unsubscribeChannel('event-list');
    // }
  }

}
